export class CLientNotFoundError extends Error {}
export class ServiceNotFoundError extends Error {}
export class EnvNotFoundError extends Error {}
export class ProductNotFoundError extends Error {}
